import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserSignUp } from '../../../models/user';

@Injectable({
  providedIn: 'root',
})
export class MtnApiService {
  constructor(
    private http: HttpClient,
  ) {}

  createUserAccountMTN(paramsRequest: { type: string; value: string }[]) {
    const apiUrl = `${environment.apiUrl}/register`;
    const body = paramsRequest;
    return this.http.post<UserSignUp>(apiUrl, body).pipe(
      map((response: UserSignUp) => {
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        throw error.message;
      })
    );
  }
}
